/**
 * The Order Queue's amber "needs attention" count button, beside Create Batch:
 * orders the queue does not list because something else holds them. One look
 * for every such button, so they read as one family:
 *
 *   Awaiting artwork (N) -> On hold   (ManualOrderQueueActions, Phase 104)
 *   Waiting on blank (N)              (WaitingOnBlankButton, BLU-1506)
 *
 * Amber outline, never a fill: it asks for a look, it is not an error. Each
 * button hides at 0.
 */
export const QUEUE_ATTENTION_BUTTON_CLASS =
  'gap-2 tabular-nums border-amber-300 text-amber-800 hover:bg-amber-50 hover:text-amber-900 dark:border-amber-700 dark:text-amber-300 dark:hover:bg-amber-950/30';

/** The pressed state of a button that toggles a view in place (aria-pressed). */
export const QUEUE_ATTENTION_BUTTON_PRESSED_CLASS =
  'bg-amber-50 text-amber-900 ring-1 ring-inset ring-amber-300 dark:bg-amber-950/30 dark:text-amber-200';
